import React from 'react'
import { saveAs } from 'file-saver'

import { exportCandidateSheet } from 'utils/sheet'

export const useExportResourceModal = state => {
  const { data } = state

  const handleExportSheet = React.useCallback(
    fileName => async () => {
      try {
        const file = await exportCandidateSheet(data, fileName)

        saveAs(file, fileName)
      } catch (error) {
        console.log({ error })
      }
    },
    [data],
  )

  const handleExportFile = React.useCallback(
    fileName => handleExportSheet(fileName),
    [handleExportSheet],
  )

  return {
    handleExportFile,
  }
}
